import { RefObject, useCallback } from 'react';

import { clamp } from 'utils/easing';

/**
 * Ported from `progress()` in dna-prototype.html.
 * Returns a stable getter (not React state) — it's meant to be polled once per
 * rAF tick, not subscribed to, so scrolling never triggers a React re-render.
 */
export const useScrollProgress = (
  trackRef: RefObject<HTMLElement>,
  stageRef: RefObject<HTMLElement>,
): (() => number) =>
  useCallback(() => {
    const track = trackRef.current;
    const stage = stageRef.current;
    if (!track || !stage) return 0;

    const rect = track.getBoundingClientRect();
    const scrollable = track.offsetHeight - stage.clientHeight;
    return scrollable > 0 ? clamp(-rect.top / scrollable, 0, 1) : 0;
  }, [trackRef, stageRef]);
